__turbopack_context__.v({
  "bulletList": "ListBlocks-module__Duogkq__bulletList",
  "industryLinks": "ListBlocks-module__Duogkq__industryLinks",
  "item": "ListBlocks-module__Duogkq__item",
  "listingSquare": "ListBlocks-module__Duogkq__listingSquare",
  "orderedList": "ListBlocks-module__Duogkq__orderedList",
});
